<template>
    <div class="phone-grid">
        <div class="grid-operator-group">
            <div class="grid-total">全部任务（{{ total }}）</div>
            <div class="grid-navbar-right">
                <el-popover placement="bottom" :width="280" trigger="click">
                    <template #reference>
                        <div class="grid-operator cursor-pointer flow-btn" @click="showFilter">
                            <el-icon class="icon-wrapper" color="#525967"><filtericon /></el-icon> 
                            筛选
                        </div>
                    </template>
                    <template #default>
                        <el-form label-position="top" :inline="true" :model="filterItem">
                            <el-form-item label-width="80px" v-if="taskType != taskTypeOptions.OwnerTask"
                                label="发起人">
                                <el-select-v2 
                                    :options="filterOptions.userOptions"
                                    class="task-filter-item"
                                    filterable
                                    v-model="filterItem.owner"
                                    placeholder="选择发起人" 
                                    :teleported="false">
                                </el-select-v2>
                            </el-form-item>
                            <el-form-item label-width="80px" v-if="!isTodoTask"
                                label="流程状态">
                                <el-radio-group v-model="filterItem.flowState">
                                    <el-radio-button value="0" label="0">流程进行中</el-radio-button>
                                    <el-radio-button value="1" label="1">流程结束</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label-width="80px" 
                                label="发起时间">
                                <el-date-picker class="task-filter-item-date"
                                    :teleported="false"
                                    v-model="filterItem.createdUtc"
                                    type="daterange"
                                    unlink-panels
                                    range-separator="到"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间"
                                />
                            </el-form-item>
                            <el-form-item label-width="80px" 
                                label="流程表单">
                                <el-select class="task-filter-item"
                                    v-model="filterItem.contentType"
                                    filterable
                                    placeholder="选择流程表单"
                                    :teleported="false">
                                    <el-option
                                        v-for="item in filterOptions.contentTypeOptions"
                                        :key="item.Value"
                                        :label="item.Text"
                                        :value="item.Value" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label-width="80px" 
                                filterable
                                label="流程节点">
                                <el-select :disabled="filterItem.contentType.length == 0"
                                    class="task-filter-item"
                                    v-model="filterItem.flowNode"
                                    filterable
                                    placeholder="选择流程节点"
                                    :teleported="false">
                                    <el-option
                                        v-for="item in filterOptions.nodeOptions"
                                        :key="item.Value"
                                        :label="item.Text"
                                        :value="item.Value" />
                                </el-select>
                            </el-form-item> 
                            <el-form-item>
                                <el-button @click.stop="queryFilter" type="primary"> <el-icon><search /></el-icon> 查询</el-button> 
                                <el-button @click.stop="resetFilter"> <el-icon><refreshRight /></el-icon>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-popover>
                
                <div class="grid-operator cursor-pointer flow-btn" @click="getDataItems(true)" >
                    <el-icon color="#525967" :class="{'is-loading' : getItemsLoading}"><refresh /></el-icon>
                    刷新
                </div>
                <el-popover placement="bottom" :width="150" trigger="click" :visible="sortVisibleState">
                    <template #reference>
                        <div class="grid-operator cursor-pointer flow-btn" @click="showSort">
                            <el-icon class="icon-wrapper" color="#525967"><sorticon /></el-icon> 
                            排序
                        </div>
                    </template>
                    <div class="task-sort">
                        <div class="task-sort-item cursor-pointer" @click="sortTask(true)">
                            最新的待办 
                            <el-icon v-if="sortDesc" color="#409eff"><check /></el-icon>
                        </div>
                        <div class="task-sort-item cursor-pointer" @click="sortTask(false)">
                            最早的待办 
                            <el-icon v-if="!sortDesc" color="#409eff"><check /></el-icon>
                        </div>
                    </div>
                </el-popover>
            </div>
        </div>
        <div v-if="dataItems.length>0" class="infinite-list-wrapper" style="overflow: auto" >
            <ul v-infinite-scroll="load"
                infinite-scroll-immediate="false"
                class="list"
                :infinite-scroll-disabled="scrollDisabled">
                    <el-card class="task-card cursor-pointer" shadow="hover" 
                        v-for="(dataItem, index) in dataItems" 
                        :key="dataItem.ContentItemId" 
                        @click="editItem(dataItem)">
                        <template #header>
                            <div class="card-header">
                                <div class="state-info">
                                    <div class="task-title">{{ dataItem.ContentType }}</div>
                                    <div class="task-node" :title="'当前节点：'+ dataItem.NodeName">
                                        <svg t="1709623110658" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13910" width="16" height="16"><path d="M911.872 640h-105.024V488a8.064 8.064 0 0 0-8.064-8H548.352V384h109.056a16.128 16.128 0 0 0 16.128-16v-288a16.128 16.128 0 0 0-16.128-16H366.592a16.128 16.128 0 0 0-16.128 16v288c0 8.832 7.232 16 16.128 16h109.056v96H225.216a8.064 8.064 0 0 0-8.064 8V640h-104.96a16.128 16.128 0 0 0-16.192 16v288c0 8.768 7.296 16 16.128 16h290.816a16.128 16.128 0 0 0 16.192-16v-288a16.128 16.128 0 0 0-16.192-16H289.92V552h444.288V640H621.056a16.128 16.128 0 0 0-16.192 16v288c0 8.768 7.296 16 16.192 16h290.816a16.128 16.128 0 0 0 16.128-16v-288a16.128 16.128 0 0 0-16.128-16zM342.4 716.032v167.936H172.736v-167.936h169.6z m84.8-408.064V140.032h169.6v168.064h-169.6z m424.064 576h-169.6v-167.936h169.6v167.936z" fill="#8a8a8a" p-id="13911"></path></svg>
                                        <span style="margin-left: 3px">{{ dataItem.NodeName }}</span>
                                    </div>
                                </div>
                                <div class="right-header">
                                    <span class="task-node">{{ dataItem.CreatedUtc }}</span>
                                    <span class="task-node" v-if="!isTodoTask" style="margin-left: 10px">
                                        <el-tag v-if="dataItem.FlowState == 0">流程进行中</el-tag>
                                        <el-tag type="success" v-else>流程结束</el-tag>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <div class="card-content">
                            <div class="creator-info">
                                <div class="x-avatar x-biz-member-avatar creator-avatar color-2" 
                                    style="width: 24px; height: 24px; line-height: 24px; font-size: 12px;">
                                    {{ (dataItem.Creator || "z").slice(0,1) }}
                                </div>
                                <span class="fx-hight-light-text name">
                                    {{ dataItem.Creator }}
                                </span>
                            </div>
                            <div class="flow-brief">
                                <div class="gridDataItem" 
                                    v-for="field in dataItem.Fields"
                                    :key="field.Name">
                                    <div class="gridItem-item-key">{{ field.DisplayName }} : </div>
                                    <div class="gridItem-item-value">{{ field.Value }}</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </ul>
                <p v-if="loading">加载数据中...</p>
        </div>
        <div id="emptyResult" v-else>
            <div class="el-empty">
                <div class="el-empty__image">
                    <svg viewBox="0 0 79 86" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="linearGradient-1-1" x1="38.8503086%" y1="0%" x2="61.1496914%" y2="100%"><stop stop-color="#FCFCFD" offset="0%"></stop><stop stop-color="#EEEFF3" offset="100%"></stop></linearGradient><linearGradient id="linearGradient-2-1" x1="0%" y1="9.5%" x2="100%" y2="90.5%"><stop stop-color="#FCFCFD" offset="0%"></stop><stop stop-color="#E9EBEF" offset="100%"></stop></linearGradient><rect id="path-3-1" x="0" y="0" width="17" height="36"></rect></defs><g id="Illustrations" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="B-type" transform="translate(-1268.000000, -535.000000)"><g id="Group-2" transform="translate(1268.000000, 535.000000)"><path id="Oval-Copy-2" d="M39.5,86 C61.3152476,86 79,83.9106622 79,81.3333333 C79,78.7560045 57.3152476,78 35.5,78 C13.6847524,78 0,78.7560045 0,81.3333333 C0,83.9106622 17.6847524,86 39.5,86 Z" fill="#F7F8FC"></path><polygon id="Rectangle-Copy-14" fill="#E5E7E9" transform="translate(27.500000, 51.500000) scale(1, -1) translate(-27.500000, -51.500000) " points="13 58 53 58 42 45 2 45"></polygon><g id="Group-Copy" transform="translate(34.500000, 31.500000) scale(-1, 1) rotate(-25.000000) translate(-34.500000, -31.500000) translate(7.000000, 10.000000)"><polygon id="Rectangle-Copy-10" fill="#E5E7E9" transform="translate(11.500000, 5.000000) scale(1, -1) translate(-11.500000, -5.000000) " points="2.84078316e-14 3 18 3 23 7 5 7"></polygon><polygon id="Rectangle-Copy-11" fill="#EDEEF2" points="-3.69149156e-15 7 38 7 38 43 -3.69149156e-15 43"></polygon><rect id="Rectangle-Copy-12" fill="url(#linearGradient-1-1)" transform="translate(46.500000, 25.000000) scale(-1, 1) translate(-46.500000, -25.000000) " x="38" y="7" width="17" height="36"></rect><polygon id="Rectangle-Copy-13" fill="#F8F9FB" transform="translate(39.500000, 3.500000) scale(-1, 1) translate(-39.500000, -3.500000) " points="24 7 41 7 55 -3.63806207e-12 38 -3.63806207e-12"></polygon></g><rect id="Rectangle-Copy-15" fill="url(#linearGradient-2-1)" x="13" y="45" width="40" height="36"></rect><g id="Rectangle-Copy-17" transform="translate(53.000000, 45.000000)"><mask id="mask-4-1" fill="white"><use xlink:href="#path-3-1"></use></mask><use id="Mask" fill="#E0E3E9" transform="translate(8.500000, 18.000000) scale(-1, 1) translate(-8.500000, -18.000000) " xlink:href="#path-3-1"></use><polygon id="Rectangle-Copy" fill="#D5D7DE" mask="url(#mask-4-1)" transform="translate(12.000000, 9.000000) scale(-1, 1) translate(-12.000000, -9.000000) " points="7 0 24 0 20 18 -1.70530257e-13 16"></polygon></g><polygon id="Rectangle-Copy-18" fill="#F8F9FB" transform="translate(66.000000, 51.500000) scale(-1, 1) translate(-66.000000, -51.500000) " points="62 45 79 45 70 58 53 58"></polygon></g></g></g></svg>
                </div>
                <div class="el-empty__description">
                    <p>暂无相关数据</p>
                </div>
            </div>
        </div>
        
    </div>
    
    <el-drawer
        class="qwe-grid-drawer"
        size="85%"
        destroy-on-close
        v-model="formItem.visibleState">
        <template #header><h2>{{ formItem.title }}</h2></template>
        <qweForm @[formEvent.operatorForm]="formSubmit"
                @[formEvent.initForm]="fromInit"
                :operation="formItem.operation"
                :contentType="formItem.contentType"
                :contentItemId = "formItem.contentItemId"
                :flowCurrentNodeId="formItem.flowCurrentNodeId"
                :passingParameter="formItem.passingParameter"
                :is-show-head="false"></qweForm>
    </el-drawer>
</template>

<style>
    :root{
        --toolBarHeight:45px;
    }

    .phone-grid{
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .grid-operator-group{
        z-index: 1;
        display: flex;
        background-color: #fff;
        height: var(--toolBarHeight);
        line-height: var(--toolBarHeight);
        padding: 0 1rem;
        box-shadow: 0 2px 8px rgb(0 0 0 / 8%);
    }

    .grid-navbar-right{
        display: flex;
        flex: 148;
        justify-content: flex-end;
        font-size: 16px;
        align-items: center;
    }

    .grid-operator{
        margin-right: 0.25em;
        display: flex;
        align-items: center;
    }

    .icon-wrapper{
        height: 1.65em !important;
        width: 1.65em !important;
        display: inline-block;
        text-align: center;
        border: none;
        border-radius: 0.25rem;
    }

    .icon-wrapper.is-active{
        background: #dcf0ff;
    }

    .infinite-list-wrapper {
        height: 100%;  
        box-sizing: border-box;
    }

    .infinite-list-wrapper .list {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .task-card{
        margin-top: 8px;
    }
    
    .task-card:last-child{
        margin-bottom: 10px;
    }

    .task-card .el-card__header{
        padding: 12px 22px;
        
    }

    .task-card .el-card__header>.card-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .task-title{
        font-weight: 700;
        font-size: 15px;
    }

    .task-node{
        font-size: 12px;
        margin-left: 16px;
        color: #838892;
        display: flex;
        align-items: center;
    }

    .task-card .card-content{
        flex: auto;
        overflow: hidden;
        display: flex;
    }

    .task-card .card-content .creator-info {
        width: 20%;
        display: flex;
        align-items: center;
        font-size: 13px;
    }

    .task-card .right-header{
        display: flex;
    }

    .x-avatar{
        text-align: center;
        margin: 0 12px;
        border-radius: 50%;
        color: #fff;
        background-color: #00aed1;
    }

    .flow-btn{
        -webkit-box-flex: 0;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-radius: 3px;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex: none;
        flex: none;
        font-size: 14px;
        height: 26px;
        line-height: 24px;
        margin-left: 10px;
        padding: 0 10px;
    }

    .flow-btn:hover {
        background: #e6e8ed;
    }

    .task-card .el-card__body{ 
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .task-card .card-content{
        height: 70px;
    }

    .state-info{
        display: flex;
        align-items: center;
    }

    .task-sort-item{
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        margin-bottom: 3px;
        align-items: center;
        padding: 5px 7px;
    }

    .task-sort-item:hover{
        background-color: #ecf5ff;
    }

    .task-filter-item{
        width:250px !important
    }

    .task-filter-item-date{
        width:230px !important
    }

    .gridDataItem{
        font-size: 14px;
        display: flex;
        margin-top: 4px;
        text-align: left;
    }


    .gridDataItem .gridItem-item-key{
        box-sizing: border-box;
        float: left;
        padding-right: 10px;
        overflow: hidden;
        color: #979797;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .gridDataItem .gridItem-item-value{
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .gridItem-card .card-suffix {
        flex: none;
        width: 2.75rem;
        height: 100%;
        padding-left: 0.15rem;
        color: #3082f2;
        font-size: 1.1rem;
        font-weight: 600;
    }

    .card-suffix>.onlyOneOperator {
        margin-bottom: 10px;
    }

    .card-suffix>.onlyOneOperator:last-child{
        margin-bottom: 0px;
    }

    .columnShowDrawerHeader{
        margin-top: 0px;
    }

    .columnShowfield-span{
        display: block !important;
    }

    .qweGird-formItem .el-drawer__header{
        padding-top: 0px;
        margin-bottom: 0px;
        border-bottom: rgb(220, 223, 230) 1px solid;
    }

    .nullWrapper>.el-drawer__body{
        padding: 0 !important;
    }

</style>

<script>
    import { Sort, CirclePlusFilled, Filter, Refresh, Check, Search, RefreshRight } from '@element-plus/icons-vue'
    import flowTask from './FlowTask'
    import qweForm from "../Form/FormItem.vue"

    export default {
        mixins:[flowTask],

        data:function(){
            return {
                
            }
        },

        components:{
            "search": Search,
            "filtericon": Filter,
            "sorticon":Sort,
            "plus":CirclePlusFilled,
            "refresh":Refresh,
            "refreshRight":RefreshRight,
            "qweForm":qweForm,
            "check": Check
        }
    }
</Script>